module.exports = __webpack_public_path__ + "static/img/icon_zhijian.0c91fb64.png";